




import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Route } from "vue-router";
import Game from '@/components/Game/Game.vue'
import { Room } from '@/class/room'

@Component({
  components: {
    Game
  }
})
export default class PlayerGallary extends Vue {
  @Prop() roomId!: string
  @Prop() playerId!: string
  room: Room = new Room(this.roomId, this.playerId)

  @Watch('$route')
  refreshMember (to: Route): void {
    this.room.setSelf(to.params.playerId)
  }

  created (): void {
    this.$watch('isStandBy', (now) => {
      if (now) {
        this.$router.replace({ name: 'room', params: { roomId: this.roomId } })
      }
    })
  }

  get isStandBy (): boolean {
    return this.room.isStandBy
  }
}
